import { render, staticRenderFns } from "./lotteryLayout.vue?vue&type=template&id=60b3c9fd&"
import script from "./lotteryLayout.vue?vue&type=script&lang=js&"
export * from "./lotteryLayout.vue?vue&type=script&lang=js&"
import style0 from "./lotteryLayout.vue?vue&type=style&index=0&id=60b3c9fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports